import * as yup from 'yup';

export const sortingCenterInfoSchema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    name: yup.string().required(t('missingName')),
  });
